import { useState } from "react";

import PropTypes from "prop-types";

// import Mui components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

// import mui icons
import ViewWeekIcon from "@mui/icons-material/ViewWeek";

import { useSelector, useDispatch } from "react-redux";
import { loadProductsVisibility } from "../../store/features/productsInfoSlice";

function ColumnVisibility({ productsSecondaryData = [], pageName = "", btnName = "Products Column Visibility", showSeperationLine = false }) {
    const position = {
        crossStudy: {
            top: "102px",
            right: "-132px",
        },
        correlation: {
            top: "-6px",
            right: "-122px ",
        },
        overall: {
            top: "0px",
            right: "-126px ",
        },
        agreement: {
            top: "4px",
            right: "-122px ",
        },
        secondary: {
            top: "0px",
            right: "-126px ",
        },
        claimsAnalysis: {
            top: "-20px",
            right: "-93px ",
        },
        claims: {
            top: "4px",
            right: "-122px ",
        },
        fragranceMetrics: {
            top: "4px",
            right: "-122px ",
        },
        preference: {
            top: "4px",
            right: "-122px ",
        },
        fragrance: {
            top: "125px",
            right: "-97px ",
        },
        productPreferenceAnalysis: {
            top: "-6px",
            right: "-130px ",
        },
        fragranceAssociation: {
            top: "9px",
            right: "-122px ",
        },
        justRight: {
            top: "4px",
            right: "-122px ",
        },
    };

    const dispatch = useDispatch();
    const productColumnVisibility = useSelector((state) => state.productsInfoStore.productsVisibility);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productsTestCodeMapData = useSelector((state) => state.studyDataStore.productTestCodeMap);

    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    // for correlation only
    // const consumerFilterStoreData = useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation);
    // const missingFiltersStoreData = useSelector((state) => state.correlationStore.missingFiltersForCorrelation);
    // const weightToggleForCorrelation = useSelector((state) => state.correlationStore.weightToggleForCorrelation);

    // Add conditions for Beauty & Wellbeing categories
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;

    const [allProductsCombinedVisible, setAllProductsCombinedVisible] = useState(true);

    const [openColumnVisibilityDialogue, setOpenColumnVisibilityDialogue] = useState(false);

    const handleColumnVisibilityDialogueClick = () => {
        setOpenColumnVisibilityDialogue((prev) => !prev);
    };

    const handleColumnVisibilityDialogueClickAway = () => {
        setOpenColumnVisibilityDialogue(false);
    };
    const handleHideColumn = (className) => {
        for (const item of document.getElementsByClassName(className)) {
            item.classList.toggle("hidden");
        }

        let obj = JSON.parse(JSON.stringify(productColumnVisibility));
        if (obj[className]) {
            obj[className] = false;
        } else {
            obj[className] = true;
        }
        dispatch(loadProductsVisibility({ ...obj }));

        // call corelation api when column gets hidden as correlation should be recalculated
        // if (pageName === "correlation") {
        //     handleFilterSubmit(obj, consumerFilterStoreData, missingFiltersStoreData, weightToggleForCorrelation);
        // }
    };

    const list = () => {
        let studyReference = "";
        return (
            <div
                style={{
                    width: "100%",
                }}
            >
                <h6
                    style={{
                        backgroundColor: "#9c27b0",
                        marginBottom: 0,
                    }}
                    className="px-4 py-2 color-white"
                >
                    {pageName === "fragrance" ? "Product Visibility" : "Products Column Visibility"}
                </h6>
                <div
                    className="px-2"
                    style={{
                        height: 400,
                        overflow: "auto",
                        background: "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)",
                    }}
                >
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>
                            {pageName === "correlation" && isBeautyAndWellbeing && (
                                <FormControlLabel
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: 13,
                                            marginLeft: "10px",
                                        },
                                    }}
                                    style={{
                                        margin: "0px 0px 10px 0px",
                                        padding: "3px 0px",
                                    }}
                                    checked={allProductsCombinedVisible}
                                    control={
                                        <Switch
                                            color="secondary"
                                            size="small"
                                            onChange={() => {
                                                for (const item of document.getElementsByClassName("checked--all_products_combined")) {
                                                    item.classList.toggle("hidden");
                                                }
                                                setAllProductsCombinedVisible((prev) => !prev);
                                            }}
                                        />
                                    }
                                    label={<span>All Products Combined</span>}
                                />
                            )}
                            {productsSecondaryData.map((datum, index) => {
                                const proTitle = `${datum?.title}__${datum?.coreDataId}`;
                                const proTestCode = productsTestCodeMapData[proTitle];
                                const key = index + 1;
                                let showLine = false;
                                if (studyReference === "") {
                                    studyReference = datum.study_reference_title;
                                } else if (studyReference !== datum.study_reference_title) {
                                    showLine = showSeperationLine;
                                    studyReference = datum.study_reference_title;
                                }

                                return (
                                    <>
                                        {showLine ? <hr style={{ width: "98%", textAlign: "right;" }} /> : ""}
                                        <FormControlLabel
                                            className={`radio_${datum.title.replace(/\s+/g, "").toLowerCase()}`}
                                            key={key}
                                            sx={{
                                                "& .MuiTypography-root": {
                                                    fontSize: 13,
                                                    marginLeft: "10px",
                                                },
                                            }}
                                            style={{
                                                // borderBottom: "1px solid grey",
                                                margin: "0px 0px 10px 0px",
                                                padding: "3px 0px",
                                            }}
                                            checked={!productColumnVisibility[`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`]}
                                            control={
                                                <Switch
                                                    color="secondary"
                                                    size="small"
                                                    onChange={() => handleHideColumn(`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`)}
                                                />
                                            }
                                            label={
                                                datum.title.includes(proTestCode) ? (
                                                    <span>
                                                        {datum?.title.split("/")[0] || ""} / {datum?.study_reference_title || ""}{" "}
                                                        {isOralCare && (
                                                            <>
                                                                <span>/</span> <span style={{ color: "#6f42c1" }}>{proTestCode}</span>
                                                            </>
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span>
                                                        {datum?.title} / {datum?.study_reference_title || ""}{" "}
                                                        {isOralCare && (
                                                            <>
                                                                <span>/</span> <span style={{ color: "#6f42c1" }}>{proTestCode}</span>
                                                            </>
                                                        )}
                                                    </span>
                                                )
                                            }
                                        />
                                    </>
                                );
                            })}
                        </FormGroup>
                    </FormControl>
                </div>
            </div>
        );
    };

    const comparisonList = () => {
        return (
            <div style={{ width: "100%" }}>
                <h6
                    style={{ backgroundColor: "#9c27b0", marginBottom: 0 }}
                    className="px-4 py-2 color-white"
                >
                    {pageName === "fragrance" ? "Product Visibility" : "Products Column Visibility"}
                </h6>

                <div
                    className="px-2"
                    style={{
                        height: 400,
                        overflow: "auto",
                        background: "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)",
                    }}
                >
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>
                            {productsSecondaryData.map((row, index) => {
                                const key = index + 1;
                                const visibilityKey = `checked--${row.backendVariable}__${row.coreDataId}`;
                                return (
                                    <FormControlLabel
                                        key={key}
                                        className={`radio_${row.backendVariable.replace(/\s+/g, "").toLowerCase()}`}
                                        sx={{
                                            "& .MuiTypography-root": {
                                                fontSize: 13,
                                                marginLeft: "10px",
                                            },
                                        }}
                                        style={{
                                            margin: "0 0 10px 0",
                                            padding: "3px 0",
                                        }}
                                        checked={!productColumnVisibility[visibilityKey]}
                                        control={
                                            <Switch
                                                color="secondary"
                                                size="small"
                                                onChange={() => handleHideColumn(visibilityKey)}
                                            />
                                        }
                                        label={<span>{row.title}</span>}
                                    />
                                );
                            })}
                        </FormGroup>
                    </FormControl>
                </div>
            </div>
        );
    };

    return (
        <ClickAwayListener
            mouseEvent="onMouseDown"
            touchEvent="onTouchStart"
            onClickAway={handleColumnVisibilityDialogueClickAway}
        >
            <div
                style={{
                    position: "relative",
                }}
            >
                <Button
                    style={{
                        ...position[pageName],
                        float: " right ",
                        clear: " both ",
                        rotate: "-90deg ",
                        background: "#9c27b0 ",
                        textTransform: " capitalize ",
                        padding: "3px 15px ",
                        border: "1px solid #9c27b0 ",
                        zIndex: "6 ",
                        fontWeight: "500 ",
                        fontSize: "0.8125rem ",
                        lineHeight: "1.75 ",
                        borderRadius: pageName === "fragrance" ? "0px" : "0px 0px 5px 0px ",
                        letterSpacing: "0.02857em ",
                        color: "#fff ",
                    }}
                    onClick={handleColumnVisibilityDialogueClick}
                    startIcon={<ViewWeekIcon />}
                >
                    {btnName !== "Products Column Visibility" ? btnName : (pageName === "fragrance" ? "Product Visibility" : "Products Column Visibility")}
                </Button>
                {openColumnVisibilityDialogue && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 75,
                            zIndex: 10,
                            bgcolor: "background.paper",
                            width: 350,
                            // height: 460,
                            maxHeight: 460,
                            height: "max-content",
                            boxSizing: "border-box",
                            right: 0,
                            overflow: "hidden",
                            boxShadow: "0px 20px 20px -10px #727272",
                        }}
                        style={{
                            borderRadius: 5,
                        }}
                    >
                        {productColumnVisibility ? (pageName === "productPreferenceAnalysis" ? comparisonList() : list()) : null}
                    </Box>
                )}
            </div>
        </ClickAwayListener>
    );
}

// Typechecking props for the OverallKpi
ColumnVisibility.propTypes = {
    productsSecondaryData: PropTypes.array,
    pageName: PropTypes.string,
    btnName: PropTypes.string,
    showSeperationLine: PropTypes.bool,
};

export default ColumnVisibility;
